<template>
    <div class="trackingRowContainer" v-if="mounted">
        <!-- NAME -->
        <div v-if="type !== 'button'" class="rowElement" :class="{sticky: sticky}"
             :style="{width: getWidthOfProp('Name')}">
            <InputDetail :background="'none'" :border="'none'" :value="this.name"
                         @input="nameChanged($event)"
                         v-if="type === 'interaction' && !dashboardView && editable"></InputDetail>
            <div v-if="type === 'formula' || dashboardView || (type === 'interaction' && !editable)"
                 style="padding-left: 11px;">{{ formulaName }}
            </div>
            <span v-if="type==='interaction'" v-tooltip="data.description" class="icon icon-info"></span>
        </div>
        <!-- TECHNISCHER NAME -->
        <div v-if="!dashboardView && type !== 'button'" class="rowElement"
             :style="{width: getWidthOfProp('Technischer Name')}">
            <div v-if="type === 'interaction'">{{ (technicalNamePrefix + data.technical_name) }}</div>
            <!--<div v-else>{{data.technical_name || ''}}</div>-->
            <span v-if="type === 'interaction' && data.technical_name !== ''" class="icon icon-clipboard"
                  @click="copyToClipboard((technicalNamePrefix + data.technical_name) || '')"
                  v-tooltip="'In die Zwischenablage kopieren'"
            ></span>
        </div>
        <div>

        </div>
        <!-- STATUS -->
        <div v-if="!dashboardView && type !== 'button'" class="rowElement statusCol"
             :style="{width: getWidthOfProp('Status')}"
             :class="{twoStatus: this.type === 'interaction'}">
            <span v-if="this.type === 'interaction'" class="icon icon-status-inprogress" :class="[statusClass]"
                  @click="checkAndChangeStatus" style="margin-right:7px;"></span>
            <div>
                <InfoBubble style="width: 60px"
                            v-if="getData('visibility') === 'extern' || getData('visibility') === ''"
                            color="pink" :disabled="true" @click="changeVisibility">extern
                </InfoBubble>
                <InfoBubble style="width: 60px" v-if="getData('visibility') === 'intern'" color="blue" :disabled="true"
                            @click="changeVisibility">intern
                </InfoBubble>
            </div>
        </div>
        <!-- BEMERKUNG -->
        <div v-if="type === 'interaction' && !dashboardView" class="rowElement"
             :class="{hide: !this.$store.state.trackingList.showCommentSection}"
             :style="{width: getWidthOfProp('Bemerkung')}">
            <div v-if="!showCommentTextArea" @click="showTextArea" class="commentDiv" v-tooltip="comment">
                {{ comment }}
            </div>
            <textarea ref="textarea" v-if="showCommentTextArea" :value="this.comment" @input="commentChanged($event)"
                      @focusout="checkComment()" style="z-index:2">
            </textarea>
        </div>
        <div v-else-if="!dashboardView && type !== 'button'" class="rowElement"
             :style="{width: getWidthOfProp('Bemerkung')}"
             :class="{hide: !this.$store.state.trackingList.showCommentSection}">
            {{ data.comment || '' }}
        </div>
        <!-- AKTION -->
        <div v-if="!dashboardView && type !== 'button'" class="rowElement actionCol"
             :style="{width: getWidthOfProp('Aktion')}">
            <span v-if="type === 'formula' && data.id === 1"
                  @click="$emit('edit', data)" class="icon icon-edit"
                  style="font-size: 1.3rem" v-tooltip="'Technischen Space Namen editieren'"></span>
            <span v-if="(type === 'interaction' && editable)"
                  @click="$emit('copy', data)" class="icon icon-duplicate"
                  style="font-size: 1.3rem"></span>
            <span v-if="(type === 'interaction' && editable) || (type === 'formula' && data.id === 1)"
                  @click="$emit('delete', data)" class="icon icon-delete"
                  style="font-size: 1.3rem"></span>
        </div>
        <!-- BESCHREIBUNG -->
        <div v-if="!dashboardView && type !== 'button'" class="rowElement"
             :style="{width: getWidthOfProp('Beschreibung')}">
            <div v-if="!showDescriptionTextArea" @click="showTextAreaDescription" class="commentDiv"
                 v-tooltip="description" :key="tmpKey">
                {{ description }}
            </div>
            <textarea ref="textareaDescription" v-if="showDescriptionTextArea" :value="description"
                      @input="descriptionChanged($event)"
                      @focusout="checkDescription()" style="z-index:2"></textarea>
        </div>
        <div v-if="showReporting && type !== 'button'" style="display: flex;">
            <div class="reportingWrapper" v-for="(insertionOrder, i) in insertionOrderOrSites"
                 :key="i+Math.floor(100000 + Math.random() * 900000)"
                 :data-engagement="findOriginalInsertionOrder(insertionOrder).engagement_hash"
                 :style="{backgroundColor: i % 2 === 0 ? '#d0d4da' : 'f7f7f9'}">
                <!-- REPORTING ANZAHL-->
                <div v-if="type === 'interaction'" class="rowElement"
                     :style="{width: (reporting(insertionOrder).count === '...' && reporting(insertionOrder).relation === '...') ? '200px' : '85px'}">
                    <div
                        v-if="reporting(insertionOrder).count === '...' && reporting(insertionOrder).relation === '...'"
                        class="flex-center" style="width:200px">
                        <div class="dot-flashing"></div>
                    </div>
                    <span v-else class="nowrap">{{ reporting(insertionOrder).count }}</span>
                </div>
                <div v-else-if="type === 'formula'" class="rowElement"
                     :style="{width: (formula_reporting(insertionOrder, i).count === '...' && formula_reporting(insertionOrder, i).relation === '...') ? '200px' : '85px'}">
                    <div
                        v-if="formula_reporting(insertionOrder, i).count === '...' && formula_reporting(insertionOrder, i).relation === '...'"
                        class="flex-center" style="width:200px">
                        <div class="dot-flashing"></div>
                    </div>
                    <span v-else class="nowrap">{{ formula_reporting(insertionOrder, i).count }}</span>
                </div>
                <!-- REPORTING RELATION-->
                <div v-if="type === 'interaction' && reporting(insertionOrder).relation !== '...'" class="rowElement"
                     :style="{width: '115px'}">
                    <div :class="{'flex-center': reporting(insertionOrder).relation === '-'}">
                        {{ reporting(insertionOrder).relation }}
                    </div>
                </div>
                <div v-else-if="type === 'formula' && formula_reporting(insertionOrder, i).relation !== '...'"
                     class="rowElement" :style="{width: '115px'}">
                    <div :class="{'flex-center': formula_reporting(insertionOrder, i).relation === '-'}">
                        {{ formula_reporting(insertionOrder, i).relation }}
                    </div>
                </div>
            </div>
        </div>
        <div v-if="dashboardView && type !== 'button'" class="rowElement description"
             :style="{width: descriptionWidth}">
            <div :title="description">{{ description }}</div>
        </div>
        <div v-if="type === 'button'" class="fullWidthButton" @click="$emit('click')"
             :style="{width: '100%'}" :class="{sticky: sticky}">
            <span class="icon icon-add"></span>
            {{ data }}
        </div>
        <Confirm title="Aufhebung der Sperre" :show="showConfirm" @close="showConfirm = false"
                 @oncancel="showConfirm = false"
                 @onok="changeStatus"
                 :options="{confirm: {title: 'Fortfahren', icon: ''},cancel: {title: 'Abbrechen', icon:''}}">
            <div>Durch diese Aktion wird die Sperrung der Tracking-Liste aufgehoben.</div>
            <br>
            <div style="padding-top: 10px">Soll die Tracking-Liste wirklich entsperrt werden?</div>
        </Confirm>
    </div>
</template>

<script>
import Utils from '../../scripts/utils';
import InfoBubble from "../../components/inputs/InfoBubble";
import InputDetail from "../../components/inputs/InputDetail";
import Confirm from "../../components/dialog/Confirm";
import moment from 'moment';

export default {
    name: "TrackingRow",
    components: {
        Confirm,
        InfoBubble,
        InputDetail
    },
    props: {
        data: [Object, String],
        spaceIndex: Number,
        type: {
            type: String,
            default: "interaction"
        },
        moduleIndex: Number,
        interactionIndex: Number,
        technicalNamePrefix: {
            type: String,
            default: ''
        },
        showReporting: Boolean,
        sticky: {
            type: Boolean,
            default: false
        },
        space: {
            type: Object
        }
    },
    data: function () {
        return {
            mounted: false,
            showCommentTextArea: false,
            showDescriptionTextArea: false,
            statusClasses: {
                'in Arbeit': 'default',
                'gecheckt': 'checked',
                'eingebaut': 'devChecked',
                'nicht eingebaut': 'icon-status-skipped'
            },
            tmpKey: 0,
            tmpStatusValue: null,
            showConfirm: false,
            descriptionWidth: null,
        }
    },
    computed: {
        statusClass() {
            return this.statusClasses[this.data.status];
        },
        reportingData() {
            return this.$store.getters['trackingList/reporting'];
        },
        formulaName() {
            if (this.data.id === 1) {
                return this.data.name + ' (' + this.data.pivot.spacename + ')';
            } else {
                return this.data.name;
            }
        },
        comment: {
            get() {
                return this.getData('comment');
            },
            set(value) {
                if (value.trim() !== "") {
                    this.setStoreValue('comment', value);
                }
            }
        },
        description: {
            get() {
                return this.getData('description');
            },
            set(value) {
                if (value.trim() !== "") {
                    this.setStoreValue('description', value);
                }
            }
        },
        name: {
            get() {
                return this.getData('name');
            },
            set(value) {
                this.setStoreValue('name', value);
            }
        },
        vuexState() {
            return this.$store.state.trackingList.data;
        },
        columns() {
            return this.$store.state.trackingList.columns;
        },
        dashboardView() {
            return this.$route.name === "showReporting";
        },
        editable() {
            let status = this.$store.state.trackingList.data.status;
            if (typeof status !== "undefined") {
                if (status.indexOf('eingebaut') !== -1) {
                    //status is pink
                    if (Object.prototype.hasOwnProperty.call(this.space, 'initial') && this.space.initial) {
                        //initial space
                        return false;
                    } else if (!Object.prototype.hasOwnProperty.call(this.space, 'initial') || !this.space.initial) {
                        //not an initial space
                        return true;
                    }
                }
            }
            return true;
        },
        buttonWidth() {
            if (this.$store.state.trackingList.tableClientRect) {
                return this.$store.state.trackingList.tableClientRect.width + 'px';
            } else {
                return '100%';
            }

        },
        rawReporting() {
            return this.$store.getters['trackingList/reporting'];
        }
        ,
        insertionOrderOrSites() {
            let abbreviations = [
                {name: 'Run of Channel', short: 'RoC'},
                {name: 'Festplatzierung', short: 'FP'},
                {name: 'Run of Site', short: 'RoS'},
            ];
            if (Object.keys(this.rawReporting).length > 0) {
                let ret = [];
                for (let i = 0; i < this.vuexState.medium.insertion_order.length; i++) {
                    let insertionOrder = this.vuexState.medium.insertion_order[i];
                    if (insertionOrder.sites.length === 0) {
                        ret.push(insertionOrder);
                        if (typeof this.rawReporting[insertionOrder.engagement_hash + '_' + insertionOrder.id] !== "undefined") {
                            let sites = this.rawReporting[insertionOrder.engagement_hash + '_' + insertionOrder.id].sites;
                            for (let j = 0; j < Object.keys(sites).length; j++) {
                                let site = this.$store.state.sites.sites.find(x => x.code === Object.keys(sites)[j]);
                                if (typeof site !== 'undefined') {
                                    let tmp = {
                                        notOG: true, // keyword so it takes data from parent (5 code rows above)
                                        id: insertionOrder.id,
                                        engagement_hash: insertionOrder.engagement_hash,
                                        sites: [site],
                                        type: (site ? site.name : Object.keys(sites)[j]) + ' ' + abbreviations.find(x => x.name === insertionOrder.type).short,
                                    };
                                    ret.push(tmp);
                                }
                            }
                        }
                    } else {
                        ret.push(insertionOrder);
                    }
                }
                return ret;
            } else {
                return this.vuexState.medium.insertion_order;
            }
        },
    },
    mounted() {
        if (this.type !== 'button') {
            if (this.$route.name === "trackinglist") {
                this.$store.commit('trackingList/setContainerHeight', document.getElementById("trackinglistContainer").scrollHeight + 'px');
            }
        }
        if (this.$store.state.sites.sites.length === 0) {
            this.$store.dispatch('sites/fetchAllAdServer');
        }
        this.mounted = true;
        this.calcDescriptionWidth();
        window.addEventListener('resize', this.calcDescriptionWidth);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.calcDescriptionWidth)
    },
    updated: function () {
        this.$nextTick(() => {
            this.$emit('rendered');
        });
    },
    methods: {
        showTextArea() {
            this.showCommentTextArea = true;
            this.$nextTick(() => {
                this.$refs['textarea'].focus();
            })
        },
        showTextAreaDescription() {
            this.showDescriptionTextArea = true;
            if (this.description === "Beschreibung editieren") this.description = "";
            this.$nextTick(() => {
                this.$refs['textareaDescription'].focus();
            })
        },
        setStoreValue(property, value) {
            if (this.type === 'formula') {
                if (property === 'description') {
                    this.$store.commit('trackingList/setFormulaProperty', {property: 'pivot.description', data: this.data, value: value});
                }
                this.$store.commit('trackingList/setFormulaProperty', {property: property, data: this.data, value: value});

            } else {
                this.$store.commit('trackingList/setInteractionProperty', {
                    property: property,
                    value: value,
                    moduleIndex: this.moduleIndex,
                    spaceIndex: this.spaceIndex,
                    interactionIndex: this.interactionIndex
                });
            }
        },
        commentChanged: function (e) {
            this.comment = e.target.value;
        },
        descriptionChanged: function (e) {
            this.description = e.target.value;
        },
        checkComment: function () {
            if (this.comment === '') {
                this.comment = 'Bemerkung editieren';
            }
            this.showCommentTextArea = false;
        },
        checkDescription: function () {
            if (this.description === '') {
                this.description = 'Beschreibung editieren';
            }
            this.showDescriptionTextArea = false;
            let date = moment;
            this.tmpKey = date.valueOf();
        },
        nameChanged: function (e) {
            this.name = e;
        },
        changeVisibility: function () {
            let visibility;
            if (this.type === "formula") {
                visibility = this.data.pivot.visibility === 'extern' ? 'intern' : 'extern';
            } else {
                visibility = this.data.visibility === 'extern' ? 'intern' : 'extern';
            }
            this.setStoreValue('visibility', visibility);
        },
        checkAndChangeStatus: function (event) {
            let order = ['default', 'checked', 'devChecked', 'icon-status-skipped'];
            let index = order.indexOf(event.target.classList[event.target.classList.length - 1]);
            let obj = this.indexesWithProp('status');
            obj.value = Utils.getKeyByValue(this.statusClasses, order[index === order.length - 1 ? 0 : index + 1]);

            if ((this.$store.state.trackingList.data.status === "eingebaut") && obj.value.indexOf('eingebaut') === -1) {
                this.tmpStatusValue = obj.value;
                this.showConfirm = true;
            } else {
                this.setStoreValue('status', obj.value);
            }
        },
        changeStatus: function () {
            this.setStoreValue('status', this.tmpStatusValue);
            this.showConfirm = false;
        },
        copyToClipboard: function (val) {
            let dummy = document.createElement("textarea");
            document.body.appendChild(dummy);
            dummy.value = val;
            dummy.select();
            try {
                document.execCommand('copy');
                this.$noty.success('Erfolgreich kopiert.');
            } catch (e) {
                console.error(e);
                this.$noty.error('Fehler beim kopieren.');
            }
            document.body.removeChild(dummy);
        },
        indexesWithProp(prop) {
            let ret = {
                spaceIndex: this.spaceIndex,
                moduleIndex: this.moduleIndex,
                interactionIndex: this.interactionIndex,
            };
            if (typeof prop !== "undefined") {
                ret.property = prop;
            }
            return ret;
        },
        reporting(insertionOrder) {
            if (Object.keys(this.reportingData).length !== 0) {
                let event_count;
                let hash_key = insertionOrder.engagement_hash + '_' + insertionOrder.id;
                if (this.reportingData[hash_key]) {
                    event_count = 0;
                    let eventName = this.technicalNamePrefix + this.data.technical_name;
                    if (insertionOrder.sites.length !== 0) {
                        for (let i = 0; i < insertionOrder.sites.length; i++) {
                            let siteName, category;
                            siteName = insertionOrder.sites[i].parent_code ? insertionOrder.sites[i].parent_code :
                                (insertionOrder.sites[i].code !== "" ? insertionOrder.sites[i].code : insertionOrder.sites[i].name);
                            if (typeof insertionOrder.sites[i].parent_code !== "undefined" && insertionOrder.sites[i].parent_code) {
                                //siteName = insertionOrder.sites[i].parent_code;
                                category = insertionOrder.sites[i].code !== "" ? insertionOrder.sites[i].code : insertionOrder.sites[i].name;
                                if (typeof this.reportingData[hash_key].categories[siteName] !== "undefined" &&
                                    typeof this.reportingData[hash_key].categories[siteName][category][eventName] !== "undefined") {
                                    event_count += this.reportingData[hash_key].categories[siteName][category][eventName];
                                }
                            } else {
                                //siteName = insertionOrder.sites[i].code !== "" ? insertionOrder.sites[i].code : insertionOrder.sites[i].name;
                                if (typeof this.reportingData[hash_key].sites[siteName] !== "undefined" &&
                                    typeof this.reportingData[hash_key].sites[siteName][eventName] !== "undefined") {
                                    event_count += this.reportingData[hash_key].sites[siteName][eventName];
                                }
                            }
                        }
                    } else {
                        event_count += (typeof this.reportingData[hash_key].events[eventName] !== "undefined" ?
                            this.reportingData[hash_key].events[eventName] : 0);
                    }
                } else {
                    event_count = null;
                }
                let impressions = Utils.calcImpressions(this.findOriginalInsertionOrder(insertionOrder).line_items, this.vuexState.medium.type);
                return {
                    count: event_count || event_count === 0 ? event_count.toLocaleString('de-DE') : '...',
                    relation: (event_count || event_count === 0) && impressions.totalAIs !== 0 ?
                        ((event_count / impressions.totalAIs) * 100).toFixed(2).toLocaleString('de-DE').replace(".", ",") + ' %' : (impressions.totalAIs === 0 ? '-' : '...')
                };
            } else {
                return {
                    count: '...',
                    relation: '...'
                };
            }

        },
        formula_reporting(insertionOrder, i) {
            if (insertionOrder.notOG) {
                return {count: '-', relation: '-'}
            } else {
                let impressions = Utils.calcImpressions(insertionOrder.line_items, this.vuexState.medium.type);
                let count = '...';
                let relation = '...';
                let hash_key = insertionOrder.engagement_hash + '_' + insertionOrder.id;
                let index = (insertionOrder.type.toLowerCase() === "festplatzierung" || insertionOrder.type.toLowerCase() === "run of site") ? i : 0;
                if (this.data.reporting && this.data.reporting[hash_key]) {
                    count = this.data.reporting[hash_key].sites[index].count.toLocaleString('de-DE');
                    relation = this.data.reporting[hash_key].sites[index].relation;
                }
                return {
                    count: count,
                    relation: impressions.totalAIs === 0 ? '-' : relation
                }
            }
        },
        getWidthOfProp(viewName) {
            if (viewName === "Name" && this.$route.name === "showReporting") {
                return this.$store.state.trackingList.dashboard.firstColWidth;
            } else {
                for (let i = 0; i < this.columns.length; i++) {
                    if (this.columns[i].viewName === viewName) {
                        return this.columns[i].width;
                    }
                }
            }
        },
        getData(prop) {
            let ret = '';
            if (this.type === 'interaction') {
                if (this.$route.name === 'showReporting') {
                    ret = this.data[prop];
                } else {
                    if (this.moduleIndex != null) {
                        ret = this.$store.state.trackingList.data.spaces[this.spaceIndex].modules[this.moduleIndex].interactions[this.interactionIndex][prop];
                    } else {
                        ret = this.$store.state.trackingList.data.spaces[this.spaceIndex].interactions[this.interactionIndex][prop];
                    }
                }

            } else if (this.type === 'formula' && this.data.name.indexOf('_sum') === -1) {
                ret = this.data.pivot[prop];
            }

            if (ret === "" || ret === null) {
                if (prop === 'comment') return 'Bemerkung editieren';
                if (prop === 'description' && !this.dashboardView) return 'Beschreibung editieren';
            }
            return ret;
        },
        calcDescriptionWidth() {
            if (this.$route.name === 'showReporting') {
                let sum = parseInt(this.getWidthOfProp('Name'));
                this.vuexState.medium.insertion_order.forEach(() => {
                    sum += (80 + 120);
                });
                this.descriptionWidth = window.innerWidth - sum - 20 + 'px';
                if (parseInt(this.descriptionWidth) < 350) this.descriptionWidth = '350px';
            } else {
                this.descriptionWidth = this.getWidthOfProp('Beschreibung');
            }
        },
        findOriginalInsertionOrder(insertionOrder) {
            if (typeof insertionOrder.notOG !== "undefined" && insertionOrder.notOG) {
                let originals = this.insertionOrderOrSites.filter(x => typeof x.notOG === "undefined");
                return originals.find(x => x.id === insertionOrder.id);
            } else {
                return insertionOrder;
            }
        }
    },
}
</script>

<style lang="scss" scoped>
textarea {
    height: fit-content;
    font-size: 10px;
    min-height: 70px;
    max-height: 200px;
    width: 100%;
}

.trackingRowContainer {
    background: #f7f7f9;
    padding: 0;
    border-bottom: 1px solid $lightGrey;
    width: max-content;
    min-width: 100%;
    display: flex;
    flex-flow: row;
    height: 35px;
}

.rowElement {
    padding: 0 10px 0 13px;
    display: flex;
    flex-flow: row;
    justify-content: space-between;
    align-items: center;
    font-size: 15px;
    word-break: break-word;
    transition: all 0.3s ease-in-out;

    .icon {
        margin-top: 4px;
        margin-right: 5px;
    }

    &.statusCol {
        word-break: normal;
    }

    &.hide {
        width: 0 !important;
        padding: 0;
        overflow: hidden;
    }

    &.description > div {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
}

.actionCol {
    padding: 5px 1.2rem 0 1.2rem;
}

.actionCol .icon, .technameCol .icon, .icon-clipboard {
    font-size: 1.3rem
}

.statusCol {
    padding-top: 6px;

    .icon.default, .icon-info {
        color: $grey;
    }

    &.twoStatus {
        padding-left: 11px;
        padding-right: 15px;
    }

    .icon {
        font-size: 1.2rem;
        margin-top: 0;

        &.checked {
            color: $blue;
        }

        &.devChecked, &.icon-status-skipped {
            color: $pink;
        }
    }
}

.icon {
    cursor: pointer;
}

.reportingWrapper {
    display: flex;
}

.icon-info {
    color: $grey;
}

@media screen and (min-width: 1025px) {
    .sticky {
        position: sticky;
        left: 0;
        background: linear-gradient(90deg, #F6F7F8 0%, #F6F7F8 95%, #F6F7F810 100%);
        z-index: 1;
    }
}

::v-deep .infoBubble {
    user-select: none;
}

::v-deep .inputContainer input {
    padding: 5px 10px;
}

.fullWidthButton {
    width: 100%;
    color: $pink;
    display: flex;
    align-items: center;
    justify-content: center;
    text-transform: uppercase;
    font-weight: 600;
    font-size: 13px;
    cursor: pointer;

    .icon {
        margin-right: 10px;
        font-size: 20px;

        &:before {
            position: relative;
            top: 3px;
        }
    }

    &.sticky {
        position: sticky
    }
}

.commentDiv {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.flex-center {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.nowrap {
    white-space: nowrap;
}
</style>